import Tasks from 'APP/Tasks';
import { IPushNotification } from 'STORE/PushNotifications/PushNotifications.types';

export async function handlePushNotification(notification: IPushNotification): Promise<void> {
  Tasks.pushNotifications.handleNewNotification(notification);
}
